import React from 'react';

export const ProductCardSkeleton = () => {
    return (
        <div className="skeleton-card w-100">
            {/* 1. Thumbnail placeholder */}
            <div className="skeleton-box skeleton-thumb" />
            
            {/* 2. Middle Button placeholder */}
            <div className="skeleton-box skeleton-btn" />
            
            {/* 3. Text details placeholder */}
            <div className="d-flex flex-column gap-6 mt-4 w-100">
                <div className="skeleton-box skeleton-price" />
                <div className="skeleton-box skeleton-title" />
                <div className="skeleton-box skeleton-title-short" />
            </div>
        </div>
    );
};

export const ProductGridSkeleton = ({ count = 8, columnsClass = "col-custom-5 col-md-3 col-sm-4 col-6" }) => {
    return (
        <>
            {Array.from({ length: count }).map((_, idx) => (
                <div key={idx} className={columnsClass} style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'center', width: '100%' }}>
                    <ProductCardSkeleton />
                </div>
            ))}
        </>
    );
};

export const ProductSliderSkeleton = ({ count = 5 }) => {
    return (
        <div className="d-flex gap-16 overflow-hidden w-100 py-12">
            {Array.from({ length: count }).map((_, idx) => (
                <div key={idx} style={{ flex: '1 0 180px', minWidth: '160px', maxWidth: '240px' }}>
                    <ProductCardSkeleton />
                </div>
            ))}
        </div>
    );
};

export const ProductDetailsSkeleton = () => {
    return (
        <div className="row gy-4">
            <div className="col-lg-6">
                <div className="skeleton-box rounded-16" style={{ width: '100%', height: '380px' }} />
                <div className="d-flex gap-12 mt-16">
                    {Array.from({ length: 4 }).map((_, idx) => (
                        <div key={idx} className="skeleton-box rounded-12" style={{ width: '70px', height: '70px' }} />
                    ))}
                </div>
            </div>
            <div className="col-lg-6 d-flex flex-column gap-16">
                <div className="skeleton-box" style={{ width: '40%', height: '24px' }} />
                <div className="skeleton-box" style={{ width: '80%', height: '32px' }} />
                <div className="skeleton-box" style={{ width: '30%', height: '28px' }} />
                <div className="skeleton-box" style={{ width: '100%', height: '60px' }} />
                <div className="skeleton-box rounded-pill" style={{ width: '50%', height: '48px' }} />
            </div>
        </div>
    );
};

export default ProductCardSkeleton;
